import type { NewsListItem } from "./contracts";
import type { Locale } from "./locale";

type Visibility = Pick<NewsListItem, "title" | "publishedAtMs">;

/**
 * 뉴스 아이템이 현재 locale + 시각 기준으로 사용자에게 노출 가능한지 판정한다.
 *
 * - 현재 locale 의 번역이 존재해야 한다 (없으면 숨김, fallback 없음).
 * - 게시일이 `nowMs` 이하여야 한다 (미래 게시는 자동 숨김 → 게시 시각 도달 후 다음 로드에 노출).
 *
 * `publishedAtMs` 가 missing 한 legacy JSON (이 변경 배포 직후 sync 가 아직 재실행되지
 * 않은 S3 데이터) 은 `0` 으로 간주해 "이미 게시됨" 으로 취급한다. 다음 sync 가 돌면
 * 정상 값으로 갱신된다.
 */
export function isNewsItemVisible(item: Visibility, locale: Locale, nowMs: number): boolean {
  const publishedMs = item.publishedAtMs ?? 0;
  return item.title[locale] !== undefined && publishedMs <= nowMs;
}

export function filterVisibleNews<T extends Visibility>(
  items: T[],
  locale: Locale,
  nowMs: number,
): T[] {
  return items.filter((item) => isNewsItemVisible(item, locale, nowMs));
}
